<template>
  <div class="c-star-rating">
    <o-icon
      v-for="n in score"
      :key="'score' + n"
      icon="favorite"
      class="c-star-rating__star"
    />
    <o-icon
      v-for="n in 5 - score"
      :key="'empty' + n"
      icon="favorite-unchecked"
      class="c-star-rating__star"
    />
  </div>
</template>

<script>
export default {
  name: 'OStarRating',
  props: {
    score: {
      type: Number,
      default: 0,
      validator: function(value) {
        return [0, 1, 2, 3, 4, 5].indexOf(value) !== -1
      }
    }
  }
}
</script>

<style lang="scss">
.c-star-rating {
  display: flex;
}

.c-star-rating__star {
  margin-right: 0.4rem !important;
}
</style>
